import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function SocialImpact() {
  return (
    <div><Navbar/><Footer/></div>
  )
}

export default SocialImpact